// Delegation also supports header sections replaced by the theme editor.
function positionEvergreenMegaMenu(item) {
  const menu = item.querySelector(':scope > .mega-menu');
  if (!menu || window.innerWidth < 990) return;

  const container = item.closest('.head-mast > .container');
  const link = item.querySelector(':scope > a');
  if (!container || !link) return;

  const containerBounds = container.getBoundingClientRect();
  const linkBounds = link.getBoundingClientRect();
  const isRtl = getComputedStyle(container).direction === 'rtl';
  const parentStart = isRtl
    ? containerBounds.right - linkBounds.right
    : linkBounds.left - containerBounds.left;
  // Align with the parent, shifting only when needed to fit inside the header.
  const maximumStart = container.clientWidth - menu.offsetWidth - 24;
  const start = Math.max(24, Math.min(parentStart, maximumStart));
  menu.style.setProperty('--evergreen-menu-start', `${start}px`);
}

function positionEvergreenMegaMenus() {
  document.querySelectorAll('.header-evergreen .navigation-main > .has-sub-menu')
    .forEach(positionEvergreenMegaMenu);
}

positionEvergreenMegaMenus();
window.addEventListener('resize', positionEvergreenMegaMenus);
document.addEventListener('shopify:section:load', positionEvergreenMegaMenus);
document.fonts.ready.then(positionEvergreenMegaMenus);

document.addEventListener('click', (event) => {
  const closeButton = event.target.closest('.evergreen-mobile-menu-close');
  if (closeButton) {
    closeButton.closest('.head-slot-nav-mobile-link-wrapper')
      .querySelector('.head-slot-nav-mobile-link').click();
  }
  const menuToggle = event.target.closest('.header-evergreen .head-slot-nav-mobile-link');
  if (menuToggle) {
    const header = menuToggle.closest('.header-evergreen');
    const badge = header.querySelector('.evergreen-mobile-cart-count');
    const cartQuantity = header.querySelector('.head-slot-cart-link-quantity');
    if (badge) badge.textContent = cartQuantity?.textContent.trim() || '0';
  }
});

document.addEventListener('keydown', (event) => {
  const item = event.target.closest('.header-evergreen .navigation-main > .has-sub-menu');
  if (!item) return;
  if (event.key === 'Escape') {
    event.preventDefault();
    item.classList.add('evergreen-menu-dismissed');
    item.querySelector(':scope > a').focus();
  } else if (event.key === 'ArrowDown') {
    event.preventDefault();
    item.classList.remove('evergreen-menu-dismissed');
    item.querySelector('.navigation-sub-menu a')?.focus();
  }
});
document.addEventListener('pointerover', (event) => {
  const item = event.target.closest('.header-evergreen .navigation-main > .has-sub-menu');
  if (item && !item.contains(event.relatedTarget)) {
    positionEvergreenMegaMenu(item);
    item.classList.remove('evergreen-menu-dismissed');
  }
});
document.addEventListener('focusin', (event) => {
  const item = event.target.closest('.header-evergreen .navigation-main > .has-sub-menu');
  if (item && !item.contains(event.relatedTarget)) {
    positionEvergreenMegaMenu(item);
    item.classList.remove('evergreen-menu-dismissed');
  }
});
